"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
interface TOCHeading {
  id: string;
  text: string;
}
export function useTableOfContents() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [headings, setHeadings] = useState(t0);
  const [activeId, setActiveId] = useState("");
  const observerRef = useRef(null);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const rafId = requestAnimationFrame(() => {
        const article = document.querySelector("article");
        if (!article) {
          return;
        }
        const h2Elements = article.querySelectorAll("h2[id]");
        const items = Array.from(h2Elements).map(_temp);
        setHeadings(items);
        if (items.length === 0) {
          return;
        }
        observerRef.current = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              setActiveId(entry.target.id);
            }
          }
        }, {
          rootMargin: "-80px 0px -60% 0px",
          threshold: 0
        });
        h2Elements.forEach(el_0 => observerRef.current.observe(el_0));
      });
      return () => {
        cancelAnimationFrame(rafId);
        observerRef.current?.disconnect();
      };
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== activeId || $[4] !== headings) {
    t3 = {
      headings,
      activeId
    };
    $[3] = activeId;
    $[4] = headings;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp(el) {
  return {
    id: el.id,
    text: el.textContent || ""
  };
}